export default "__VITE_ASSET__DL7ISSpU__"